import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-sm-10 intro-text">

                {/* Badge strip */}
                <motion.div
                  className="hero-badges"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                >
                  <span className="hero-badge"><i className="fa fa-certificate"></i> UAE Licensed</span>
                  <span className="hero-badge"><i className="fa fa-globe"></i> Sea · Air · Road</span>
                  <span className="hero-badge"><i className="fa fa-map-marker"></i> UAE</span>
                </motion.div>

                <motion.h1
                  initial={{ opacity: 0, y: 40 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: 0.25 }}
                >
                  {props.data ? props.data.title : "Loading"}
                </motion.h1>

                <motion.div
                  className="hero-slogan"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.38 }}
                >
                  <i className="fa fa-globe"></i> Connecting Cargoes Worldwide
                </motion.div>

                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: 0.45 }}
                >
                  {props.data ? props.data.paragraph : "Loading"}
                </motion.p>

                <motion.div
                  className="hero-cta-group"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.65 }}
                >
                  <Link to="/contact" className="btn btn-custom btn-lg">
                    Get a Free Quote
                  </Link>
                  <Link to="/services" className="btn btn-hero-outline btn-lg">
                    Our Services <i className="fa fa-arrow-right"></i>
                  </Link>
                </motion.div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
